<script>
    import Form from 'vform'

    export default {
        layout: 'default',
        metaInfo () {
            return { title: this.$t('reset_password') }
        },

        data: () => ({
            status: '',
            form: new Form({
                email: ''
            })
        }),

        methods: {
            async send () {
                const { data } = await this.form.post('/api/password/email')

                this.status = data.status

                this.form.reset()
            }
        }
    }
</script>

<template>
    <div class="row email">
        <div class="col-lg-8 m-auto">

            <h1 class="title">{{ $t('reset_password') }}</h1>
            <h2 class="sub-title">{{ $t('reset_password_subtitle') }}</h2>

            <form @submit.prevent="send" @keydown="form.onKeydown($event)">
                <alert-success :form="form" :message="status"></alert-success>

                <!-- Email -->
                <div class="form-group row">
                    <label class="col-md-3 col-form-label text-md-right">{{ $t('email') }}</label>
                    <div class="col-md-7">
                        <input v-model="form.email" type="email" name="email" class="form-control"
                               :class="{ 'is-invalid': form.errors.has('email') }">
                        <has-error :form="form" field="email"></has-error>
                    </div>
                </div>

                <!-- Submit Button -->
                <div class="form-group row">
                    <div class="col-md-9 ml-md-auto button-wrapperи">
                        <v-button :loading="form.busy">{{ $t('send_password_reset_link') }}</v-button>
                        <router-link :to="{ name: 'login' }">
                            {{ $t('I_remembered_password') }}
                        </router-link>
                    </div>
                </div>
            </form>

        </div>
    </div>
</template>





// WEBPACK FOOTER //
// resources/assets/js/pages/auth/password/email.vue